import JSZip from 'jszip';

/**
 * Compresses files into a zip file
 * Requires `jszip` package
 * @param files
 */
export const compressFiles = (files: { name: string; blob: Blob }[]) => {
  const zip = new JSZip();

  // eslint-disable-next-line no-restricted-syntax
  for (const file of files) {
    zip.file(file.name.replace(/[^a-zÀ-úA-Z0-9._]/gi, ''), file.blob);
  }

  return zip.generateAsync({ type: 'blob' });
};
